/**
 * Custom paint add-on (snippets/custom-paint-addon.liquid).
 *
 * Keeps the selected paint property in step with the radio group, and the
 * product's displayed price in step with the selected control on pages
 * without the Quick Pro configurator. Quick Pro pages already own the price
 * through assets/quickpro-configurator.js, which counts the paint itself, so
 * this script leaves those alone — two writers on one price element would
 * fight. The cart line is added by assets/product-form.js either way.
 */
(function customPaintAddon() {
  'use strict';

  if (window.__raceitCustomPaint) return;
  window.__raceitCustomPaint = true;

  /** Same Intl formatting as the Quick Pro summary ("1.300 €" in Spanish). */
  function money(cents, currency, lang) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(lang || 'es', {
        style: 'currency',
        currency: currency || 'EUR',
        useGrouping: 'always',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function rootOf(el) {
    return el.closest('.js-product') || el.closest('.shopify-section') || document;
  }

  function sync(root) {
    root.querySelectorAll('[data-custom-paint-group]').forEach(function (group) {
      var property = group.querySelector('[data-custom-paint-property]');
      if (!property) return;
      var checked = group.querySelector('[data-custom-paint]:checked:not([disabled])');
      var value = checked ? checked.dataset.customPaintValue || '' : '';
      property.value = value;
      property.disabled = !value;
    });

    if (root.querySelector('[data-quickpro-setup]')) return;
    var control = root.querySelector('[data-custom-paint]');
    var priceSource = root.querySelector('[data-public-variant-price-source]');
    if (!control || !priceSource) return;

    var base = Number(priceSource.dataset.price || 0);
    if (!base) return;
    var checked = root.querySelector('[data-custom-paint]:checked:not([disabled])');
    var extra = checked ? Number(checked.dataset.customPaintPrice || 0) : 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();

    var currentValue = priceSource.querySelector('.price__current .js-value');
    if (currentValue) currentValue.textContent = money(base + extra, currency, lang);

    var compareAt = Number(priceSource.dataset.compareAtPrice || 0);
    var compareValue = priceSource.querySelector('.price__was .js-value');
    if (compareValue && compareAt > base) {
      compareValue.textContent = money(compareAt + extra, currency, lang);
    }

    priceSource.dataset.raceitAddonAdjustment = String(extra);
    priceSource.classList.toggle('product-info__price--configured', extra > 0);
  }

  function syncAll() {
    document.querySelectorAll('[data-custom-paint]').forEach(function (box) { sync(rootOf(box)); });
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest ? event.target.closest('[data-custom-paint]') : null;
    if (box) sync(rootOf(box));
  });

  // A variant change re-renders the price block with the new base price.
  document.addEventListener('on:variant:change', function () { setTimeout(syncAll, 0); });
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('pageshow', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
}());
